import {memo} from 'react'

import type {SmartDetectorProps} from '../SmartDetectors.types'

import useCliErrorMessage from './useCliErrorMessage'

import PopupError from 'src/components/pages/PipelinesPages/components/common/PopupError/PopupError'

function CliErrorMessage(props: SmartDetectorProps) {
  const {anchorElement} = props
  const {cliErrorMessage, isShowPopupError} = useCliErrorMessage(props)

  if (isShowPopupError) {
    return <PopupError anchorElement={anchorElement} error={cliErrorMessage} />
  }

  return null
}

export default memo(CliErrorMessage)
